"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var fontSizes = [14, 16, 18, 20, 24, 36, 48, 60];
var _default = fontSizes;
exports["default"] = _default;